<template>
  <v-app>
    <router-view />
    <notify />
  </v-app>
</template>

<script>
import Notify from '@/components/Notify'
import faviconAndTitle from '@/mixins/faviconAndTitle'

export default {
  name: 'App',
  mixins: [faviconAndTitle],
  components: {
    Notify
  },

  data: () => ({
    //
  }),

  created() {
    this.$store.dispatch('setHostName')
  }
};
</script>
